export class Readable {
  static from() {
    return new Readable();
  }

  pipe() {
    return this;
  }
}

export default { Readable };
